import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForumComponent } from './forum/forum.component';
import { HeaderComponent } from './forum/header/header.component';
import { KnowledgeBaseSubCategoryComponent } from './forum/knowledge-base-subCategory/knowledge-base-subCategory.component';
import { subCategoryAnswersComponent } from './forum/subCategory-answers/subCategory-answers.component';
import { KnowledgeBaseComponent } from './forum/knowledge-base/knowledge-base.component';
import { CreateTicketFormComponent } from './forum/create-ticket-form/create-ticket-form.component';
import { LetsChatComponent } from './forum/lets-chat/lets-chat.component';
import { KnowledgeBaseSubCategoryChildComponent } from './forum/knowledge-base-sub-category-child/knowledge-base-sub-category-child.component';

const routes: Routes = [
  {
    path: '',
    component: ForumComponent,
    children: [
      {
        path: 'header', // child route path
        component: HeaderComponent, // child route component that the router renders
      },
      {
        path: 'lets-chat',
        component: LetsChatComponent,
      },
    ],
  },
  { path: 'ticketCreation', component: CreateTicketFormComponent },
  { path: ':cname', component: KnowledgeBaseComponent },
  { path: ':cname/:sname', component: KnowledgeBaseSubCategoryComponent },
  { path: ':cname/:sname/:qname', component: subCategoryAnswersComponent },
  { path: ':cname/:sname/subCategory/:scname', component: KnowledgeBaseSubCategoryChildComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}